import { render, staticRenderFns } from "./UpdateBusinessMemberKnownAllergies.vue?vue&type=template&id=4565eb69&"
import script from "./UpdateBusinessMemberKnownAllergies.vue?vue&type=script&lang=js&"
export * from "./UpdateBusinessMemberKnownAllergies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports